import "@hotwired/turbo-rails"
import "../../javascript/controllers"
import "../../javascript/turbo_mount"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// Disable preloading
document.addEventListener("turbo:before-prefetch", (event) => {
  event.preventDefault()
})



// https://github.com/hotwired/turbo-rails/issues/483
Turbo.StreamActions.redirect_to = function () {
  const url = this.getAttribute('url') || '/'
  Turbo.visit(url)
}

// https://github.com/hotwired/turbo/issues/1239#issuecomment-2318499236
addEventListener("turbo:before-morph-attribute", (event) => {
  if (event.target instanceof HTMLDialogElement &&
    event.detail.attributeName === "open" &&
    event.detail.mutationType === "remove") {
    event.preventDefault()
    event.target.close()
  }
})

// In offline mode, turbo shouldn't do anything about a request error because the service
// worker will handle it. This also means turbo won't do anything in online mode,
// but again, the service worker will handle it.
addEventListener("turbo:fetch-request-error", (event) => {
  event.preventDefault()
})